// extracted by mini-css-extract-plugin
export var bodywrapper = "categories-module--bodywrapper--GZ5DQ";
export var categorytitle = "categories-module--categorytitle--JiO-f";